export default "__VITE_ASSET__DtxK0Vug__"